<template>
  <el-container id="adb">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background: #F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px"> {{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-aside width="260px" style="background:#FFFFFF;height:100%">
        <el-header height="60px" style="padding:15px;
          display:flex;align-items:center;">
          <p style="width:auto;height:auto;font-size:20px;font-weight:bold;">设备类型</p>
        </el-header>
        <ul class="left_main" style=" height:calc(80vh);width:auto;background:#FFFFFF">
          <li v-for="(g,index) in li_pid" :key="g.id" @click="btnClick(index)"
              style="height:40px;margin-bottom:5px;margin-left:8px;margin-right:8px;"
              :class="{active:currentIndex === index,active1:currentIndex !== index}">
            <div style="display:flex;width:auto;height:40px;line-height:0.4;">
              <p style="width:100%;text-align:left;margin-left:15px;">{{ g.label }}</p>
            </div>
          </li>
        </ul>
      </el-aside>
      <el-container style="padding-left:15px;background: #F4F4F4">
        <el-main class="div_right_main">
          <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
            <p style="width:100px;font-size:20px;font-weight:bold;">设备列表</p>
            <span style="margin-left:auto;color: #ffffff; font-size: 13px">
              <el-select v-model="edi_state" ref='select'
                         @visible-change='show_change'
                         clearable filterable placeholder="设备状态"
                         style="width:10vw;">
                <el-option
                    v-for="item in li_state"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </span>
            <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
              <el-input
                  placeholder="输入设备名称查询"
                  style="width:10vw;"
                  prefix-icon="el-icon-search"
                  clearable
                  v-model="scan_name">
              </el-input>
            </span>
            <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
              <el-input
                  placeholder="输入设备MAC查询"
                  style="width:10vw;"
                  prefix-icon="el-icon-search"
                  clearable
                  v-model="scan_mac">
              </el-input>
            </span>
            <!--            <el-button @click="addDev" size="small" type="primary" icon="el-icon-plus"
                                   style="margin-left:auto;margin-right:15px">
                          新增人员
                        </el-button>-->
          </div>
          <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                    style="width:100%; font-size:13px; background:#F4F4F4;margin-top:10px"
                    :max-height=maxHeight show-overflow-tooltip :row-key="rowKey"
                    :header-cell-style="{'text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
            <el-table-column width="01" sortable/>
            <div v-for="(d,item) in this.defHead" :key=item>
              <el-table-column v-if="d.key!=='设备状态'"
                               :prop=d.val :label=d.key :width="d.w" sortable>
              </el-table-column>
              <el-table-column v-else :label=d.key width="200">
                <template slot-scope="scope">
                  <p @click="query_device(scope.row)"
                     style="font-size: 16px">{{ scope.row["statusName"] }}
                  </p>
                </template>
              </el-table-column>
            </div>
            <el-table-column
                label="状态"
                width="200">
              <template slot-scope="scope">
                <el-button @click="find_dvcState(scope.row)" type="text" size="small"
                           style="color:#1D66DD;font-size: 16px">触发
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="200">
              <template slot-scope="scope">
                <el-button v-if="scope.row.pid==='ble_gateway'" @click="syn_dvc(scope.row)" type="text" size="small"
                           style="color:#1D66DD;font-size: 16px">同步
                </el-button>
                <el-button v-else @click="ctrol_dvc(scope.row)" type="text" size="small"
                           style="color:#1D66DD;font-size: 16px">控制
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              style="float:right; margin-right:0.5vw;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange1"
              :current-page="currentPage"
              :page-sizes="[20, 40, 80, 160, 320]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog :title=titles center :close-on-click-modal="false"
               width="20vw" class="dialog_daiAddDev"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiCtrol'> <!--v-draggable 拖动-->
      <div v-for="d in li_ctl"
           style="display:flex;margin-bottom:30px;height:50px;width:100%;line-height:0.3;text-align:left;align-items:center;">
        <span style="margin-left:1vw; width:80px; color: #000000; font-size: 13px">
            {{ d.desc }}：
        </span>
        <el-select v-if="d.type==='enum'" v-model="d.value" ref='select1'
                   clearable filterable placeholder="设备状态"
                   style="width: 8vw;">
          <el-option
              v-for="item in d.li_d"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input-number v-else-if="d.type==='int'" size="medium" v-model="d.value" style="width:8vw;"
                         :step=parseInt(d.step) :min=parseInt(d.min) :max=parseInt(d.max)>
        </el-input-number>
        <el-input-number v-else-if="d.type==='float'" size="medium" v-model="d.value" style="width:8vw;"
                         :precision="2" :step=parseFloat(d.step) :min=parseFloat(d.min) :max=parseFloat(d.max)>
        </el-input-number>
        <el-button @click="on_pwr(d.name,d.value)" type="primary" style="margin-left:1vw">发送</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name:"adb",
  data() {
    return {
      total:0,
      page:1,
      pageSize:20,
      currentPage:1,
      titles:"",
      h_text:"设备控制",
      li_ctl:[],
      li_h_text:[
        {"text":"设备管理","colour":"#B7B7B7","pages":""}
      ],
      maxHeight:window.innerHeight - 350,
      daiCtrol:false,
      did:"",
      pid:"",
      defHead:[
        {'key':"序号",'val':"item","w":"200px"},
        {'key':"设备名称",'val':"devName","w":"auto"},
        {'key':"MAC地址",'val':"devMac","w":"auto"},
        {'key':"所属区域",'val':"devArea","w":"auto"},
        {'key':"设备状态",'val':"statusName","w":"auto"}
      ],
      tabData:[
        /*{'item': "1", 'dev_type': "item", "devName": "auto", "devMac": "auto"},*/
      ],
      li_dev_type:[ /*电表分组列表*/
        {name:"空调"},
        {name:"网关"},
        {name:"电表"},
        {name:"雷达灯"},
        {name:"开关面板"},
        {name:"情景面板"},
        {name:"温湿度传感器"}
      ],
      currentIndex:- 1,
      edi_pid:"",
      li_pid:[], /*角色列表*/
      li_dev:[],
      edi_state:"",
      scan_mac:"",
      scan_name:"",
      li_state:[],
      edi_pwr:1,
      li_pwr:[
        {
          value:1,
          label:'打开'
        },
        {
          value:0,
          label:'关闭'
        }
      ]
    };
  },
  methods:{ /*方法存放*/
    btnClick(index) {
      this.currentIndex = index;
      this.edi_pid = this.li_pid[index]['value'];
      this.init_View();
      // this.getDev(this.li_pid[index]['value'])
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.init_View();
    },
    handleCurrentChange1(val) {
      this.currentPage = val;
      this.init_View();
    },
    rowKey(row) {
      return row.id;
    },
    on_pwr(name,value) {
      let params = {
        "did":this.did,
        "pid":this.pid,
        "cmd":{},
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      params["cmd"][name] = value;
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.deviceCtrl,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("控制成功");
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.success("控制失败");
        }
      });
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    query_device(row) {
      const params = {
        "did":row.did,
        "pid":row.pid,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.queryDevice,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success(res.data.msg);
        row["statusId"] = res.data.data["ioTPidDevice"]["status"]["id"];
        row["statusName"] = res.data.data["ioTPidDevice"]["status"]["name"];
        let id1 = this.tabData.findIndex((index) => { /*js快速查找数组索引*/
          if (index['did'].toLowerCase() === row.did) {
            return true;
          }
        });
        if (id1 !== - 1) {
          this.tabData[id1] = row;
          console.log(row);
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("查询设备数据失败");
        }
      });
    },
    find_dvcState(row) { /*查询设备状态*/
      const params = {
        "did":row.did,
        "pid":row.pid,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.trigQueryDeviceState,params,headers).then(res => {
        console.log(res.data.msg);
        this.$message.success(res.data.msg);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("触发设备上报失败");
        }
      });
    },
    syn_dvc(row) {
      console.log(row);
      this.did = row.did;
      this.pid = row.pid;
      this.synPidArg(row.pid);
    },
    ctrol_dvc(row) {
      console.log(row);
      this.did = row.did;
      this.pid = row.pid;
      this.titles = row.devName;
      this.getPidArg(row.pid);
    },
    synPidArg(pid) { /*同步设备信息*/
      const params = {
        "did":this.did,
        "pid":pid,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.syncBleGatewayState,params,headers).then(res => {
        console.log(res.data);
        this.$message.success("同步设备信息成功");
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("同步设备信息失败");
        }
      });
    },
    getPidArg(pid) {
      const params = {
        'pid':pid
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getPidArg,params,headers).then(res => {
        console.log(res.data.data);
        let data = res.data.data["iotPidProfile"]["properities"];
        let l = [];
        for (let i = 0; i < data.length; i ++) {
          let d = {
            "name":data[i]['name'],
            "desc":data[i]['desc'],
            "type":data[i]["define"]['type'],
            "value":""
          };
          if (d['type'] === 'int') {
            d["step"] = data[i]["define"]["step"];
            d["min"] = data[i]["define"]["min"];
            d["max"] = data[i]["define"]["max"];
            d["value"] = data[i]["define"]["min"];
          }
          if (d['type'] === 'enum') {
            let l1 = [];
            for (let j = 0; j < data[i]["define"]["mapping"].length; j ++) {
              l1.push({
                "label":data[i]["define"]["mapping"][j]["desc"],
                "value":parseInt(data[i]["define"]["mapping"][j]["value"])
              });
            }
            d["li_d"] = l1;
            d["value"] = parseInt(l1[0]["value"]);
          }
          l.push(d);
        }
        this.li_ctl = l;
        this.daiCtrol = true;  /*显示控制弹窗*/
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    show_change(item) {
      if (item) {
        this.$refs.select.focus();
      } else {
        this.$refs.select.blur();
      }
    },
    show_change1(item) {
      if (item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    init_View() {
      let l = [];
      let l1 = [];
      let data = this.li_dev;
      let li_d = [];
      let j = 1;
      for (let i = 0; i < data.length; i ++) {
        let d = {
          item:j,
          did:data[i]['did'],
          pid:data[i]['pid'],
          authName:data[i]['sysIotPid']['name'],
          devName:data[i]['name'],
          devMac:data[i]['did'],
          statusId:data[i]['statusId'],
          statusName:data[i]['status']['name'],
          roomId:data[i]['roomId']
        };
        if (data[i]['roomId']) {
          d['floorId'] = data[i]['room']['floorId'];
          if (data[i]['room']['floor']) {
            d['buildId'] = data[i]['room']['floor']['buildingId'];
            d['devArea'] = data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            if (data[i]['room']['floor']['building']) {
              d['devArea'] = data[i]['room']['floor']['building']['name'] + "-" + data[i]['room']['floor']['name'] + "-" + data[i]['room']['name'];
            }
          }
        } else if (data[i]['floorId']) {
          d['floorId'] = data[i]['floorId'];
          if (data[i]['floor']) {
            d['buildId'] = data[i]['floor']['buildingId'];
            d['devArea'] = data[i]['floor']['name'];
            if (data[i]['floor']['building']) {
              d['devArea'] = data[i]['floor']['building']['name'] + "-" + data[i]['floor']['name'];
            }
          }
        }
        // const aliceItems = this.li_pid.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        //   return fruit['value'] === d.pid;
        // })
        // if (aliceItems !== undefined) {
        //   d["devType"] = aliceItems["label"];
        // }
        // if (!d["statusId"]) {
        //   d["statusId"] = 2
        //   d["devState"] = "离线"
        // } else {
        //   const state = this.li_state.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
        //     return fruit['value'] === d.statusId;
        //   })
        //   if (state !== undefined) {
        //     d["devState"] = state["label"];
        //   }
        // }
        const stateItems = l1.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
          return fruit['value'] === d['statusId'];
        });
        if (stateItems === undefined) {
          l1.push({
            value:d['statusId'],
            label:d['statusName']
          });
        }
        const authItems = l.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
          return fruit['value'] === d['pid'];
        });
        if (authItems === undefined) {
          l.push({
            value:d['pid'],
            label:d['authName']
          });
        }
        li_d.push(d);
        j += 1;
      }
      this.tabData = li_d;
      this.li_pid = l;
      this.li_state = l1;
    },
    getDev() { /*"pid": pid,*/
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getDeviceList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_dev = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    getPid() {
      const params = {
        'page':this.page,
        'pageSize':1000
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getPidList,params,headers).then(res => {
        console.log(res.data.data);
        let data = res.data.data.list;
        let l = [];
        for (let i = 0; i < data.length; i ++) {
          let d = {
            value:data[i]['pid'],
            label:data[i]['name']
          };
          l.push(d);
          this.edi_pid = l[0]['value'];
        }
        this.li_pid = l;
        this.getDev(data[0]['pid']);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备类型失败");
        }
      });
    },
    getDeviceStatus() {
      const params = {
        'page':this.page,
        'pageSize':1000
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getDeviceStatusList,params,headers).then(res => {
        let data = res.data.data.list;
        let l = [];
        for (let i = 0; i < data.length; i ++) {
          let d = {
            value:data[i]['id'],
            label:data[i]['name']
          };
          l.push(d);
        }
        this.li_state = l;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备类型失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    // this.getDeviceStatus() /*获取筛选设备状态列表*/
    // this.getPid()
    this.getDev();
  },
  computed:{ /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        if (this.edi_pid && item.pid !== this.edi_pid) {
          this.state = false;
        }
        if (this.edi_state && item.statusId !== this.edi_state) {
          this.state = false;
        }
        if (this.scan_name && !item.devName.includes(this.scan_name)) {
          this.state = false;
        }
        if (this.scan_mac && !item.devMac.includes(this.scan_mac)) {
          this.state = false;
        }
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#adb {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.left_main {
  width: 100%;
  padding: 0;
  margin: 0;
  list-style-type: none;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}


.left_footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  text-align: center;
  padding: 10px 0;
  line-height: 0.3;
}

.div_right_head {
  margin: 0;
  padding: 15px;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: start;
  background: #FFFFFF;
}

.right_head_dev {
  height: 70%;
  display: flex;
  align-items: center;
  background: #ECF2FE;
  margin-top: 15px;
  border-radius: 5px 5px 5px 5px;
}

.div_right_main {
  padding: 15px;
  background: #FFFFFF;
}

.active {
  font-size: 16px;
  background: #E7F0FF;
  color: #134FC2;
  border-radius: 6px 6px 6px 6px;
}

.active1 {
  font-size: 16px;
  background: #F7F7F7;
  border-radius: 6px 6px 6px 6px;
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(90% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}

.el-divider--horizontal { /*分割线样式*/
  margin: 0px 0% 0% 0%; /*上 右 下 左*/
  width: 100%;
  background: #F2F2F2;
}
</style>



// WEBPACK FOOTER //
// src/pages/gls/glDev.vue